import { useCallback, useMemo } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useStorage } from '@/js/libs/hooks/useStorage';
const useSessionStorageFilters = (scope, key) => {
    const { loadJSON, saveJSON, removeItem } = useStorage({ scope, storage: window.sessionStorage });
    const loadFilters = useCallbackRef(() => loadJSON(key));
    // issue with inferring types if use useCallbackRef
    // eslint-disable-next-line no-restricted-syntax
    const loadStorageFilter = useCallback((name) => {
        const filters = loadFilters();
        return filters?.[name] ?? null;
    }, [loadFilters]);
    // issue with inferring types if use useCallbackRef
    // eslint-disable-next-line no-restricted-syntax
    const saveStorageFilter = useCallback((name, value) => {
        const filters = loadFilters();
        const updatedFilters = {
            ...filters,
            [name]: value,
        };
        saveJSON(key, updatedFilters);
    }, [loadFilters, saveJSON, key]);
    // issue with inferring types if use useCallbackRef
    // eslint-disable-next-line no-restricted-syntax
    const removeStorageFilter = useCallback((name) => {
        const filters = loadFilters();
        if (filters && typeof filters === 'object' && name in filters) {
            const { [name]: _, ...updatedFilters } = filters;
            saveJSON(key, updatedFilters);
        }
    }, [loadFilters, saveJSON, key]);
    const clearStorageFilter = useCallbackRef(() => {
        removeItem(key);
    });
    return useMemo(() => ({
        saveStorageFilter,
        loadStorageFilter,
        clearStorageFilter,
        removeStorageFilter,
    }), [loadStorageFilter, saveStorageFilter, clearStorageFilter, removeStorageFilter]);
};
export default useSessionStorageFilters;
